<script setup lang="ts">
import Button from "@/cms/components/ui/button/Button.vue";
import { ButtonProps } from "@/cms/primitives/Button/Button.types.ts";
import Text from "@/cms/primitives/Text/Text.vue";
import { computed } from "vue";
import { TextProps } from "@/cms/primitives/Text/Text.types.ts";
import Tooltip from "@/cms/primitives/Tooltip/Tooltip.vue";

const { size = "default" } = defineProps<ButtonProps>();

const textVariant = computed(() => {
  /*
  Here we map the button size to a text variant
   */
  const map: {
    xs: TextProps["variant"];
    sm: TextProps["variant"];
    lg: TextProps["variant"];
    default: TextProps["variant"];
  } = {
    xs: "body-small",
    sm: "body",
    lg: "body-large",
    default: "body",
  };
  return map[size];
});
</script>

<template>
  <Tooltip v-if="tooltip" :title :align="tooltipAlign" :side="tooltipSide">
    <Button :variant :size="label ? size : 'icon'" :disabled>
      <slot name="icon-left" />
      <Text v-if="label" as="span" :variant="textVariant">{{ label }}</Text>
    </Button>
  </Tooltip>
  <Button v-else :variant :size="label ? size : 'icon'" :disabled :title>
    <slot name="icon-left" />
    <Text v-if="label" as="span" :variant="textVariant">{{ label }}</Text>
  </Button>
</template>
